module.exports = __webpack_public_path__ + "img/certificate1.486dc585.jpg";